import script from "./SiteSwitcher.vue?vue&type=script&setup=true&lang=js"
export * from "./SiteSwitcher.vue?vue&type=script&setup=true&lang=js"

import "./SiteSwitcher.vue?vue&type=style&index=0&id=55d58d7e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55d58d7e"]])

export default __exports__